import React from "react";
import FrontAbstract from "./../assets/journals/frontabstract.jpg";
import FrontField from "./../assets/journals/frontfield.jpg";
import BackAbstract from "./../assets/journals/backabstract.jpg";
import BackField from "./../assets/journals/backfield.jpg";

const StoreLandingCard = () => {
  return (
    <div className="bg-white p-4 lg:px-12 lg:py-8 mt-16 myShadow flex justify-between flex-col-reverse lg:flex-row rounded-xl w-full lg:w-10/12 m-auto">
      <div className="flex justify-between gap-4 w-full">
        <img
          src={FrontAbstract}
          alt="Abstract design front page"
          className="w-fit lg:w-64 rounded-lg"
        />
        <img
          src={BackAbstract}
          alt="Abstract design front page"
          className="w-64 rounded-lg hidden md:block"
        />
        <img
          src={FrontField}
          alt="Abstract design front page"
          className="w-64 rounded-lg hidden lg:block"
        />
        <img
          src={BackField}
          alt="Abstract design front page"
          className="w-64 rounded-lg hidden lg:block"
        />
      </div>
    </div>
  );
};

export default StoreLandingCard;
